import React from 'react';

import {EventReviewFeedback} from 'src/modules/ai';
import {HighlighterWrapper} from 'src/modules/event-review/highlighter/highlighter-wrapper';
import {HighlightFields} from 'src/modules/event-review/typedefs';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';
import {EventType} from 'src/openapi/models/EventType';
import {capitalize} from 'src/utils/capitalize';

import {Group, Item} from '@pb/kit-component-group';

type Props = {
    changeRequest: ChangeRequest,
    eventCodeInfo: EventDetailInfo | null,
    highlightsInfo: Record<HighlightFields, boolean> | null,
};

export const Reported = (props: Props) => {
    const {
        changeRequest,
        eventCodeInfo,
        highlightsInfo,
    } = props;

    return (
        <>
            {changeRequest.event.type === EventType.USER_EVENT ? (
                <Group>
                    <Group>
                        <strong>Reported:</strong>
                        <EventReviewFeedback changeRequestId={changeRequest.id} fieldName={HighlightFields.reported}/>
                    </Group>
                    <HighlighterWrapper
                        actualValue={eventCodeInfo ? capitalize(eventCodeInfo.reported.toString()) : ''}
                        changeRequestValue={capitalize(changeRequest.event.reported.toString())}
                        highlight={!!highlightsInfo?.[HighlightFields.reported]}>
                        <Item>
                            {capitalize(changeRequest.event.reported.toString())}
                        </Item>
                    </HighlighterWrapper>
                </Group>
            ) : null}
        </>
    );
};
